import { apiFetch } from "./client";
import type { Page } from "./admin";

export type RepInMarket = {
  userId: string;
  name: string;
  email: string;
  coverage: "MARKET" | "COUNTRY";
  countries: string[];
};

export type CountryStat = {
  countryCode: string;
  companyCount: number;
  invoicedOrdersYtd: number | null;
};

export type MarketOverview = {
  id: string;
  name: string;
  description: string | null;
  countryCodes: string[];
  companyCount: number;
  salesRepCount: number;
  invoicedOrdersYtd: number | null;
  kpiTargetYtdEur: string | null;
  salesReps: RepInMarket[];
  countries: CountryStat[];
};

export type CompanyInMarket = {
  id: string;
  name: string;
  country: string;
  city: string | null;
  primarySalesUserId: string | null;
  primarySalesName: string | null;
  invoicedOrdersYtd: number | null;
};

export const marketsOverviewApi = {
  overview: () => apiFetch<MarketOverview[]>("/markets/overview"),
  // Srbija ima 11.483 kupca, pa se zemlja čita po stranama. Veličina ide u adresu i kad je
  // podrazumevana, da se sa ekrana vidi šta je traženo.
  companiesInCountry: (code: string, page = 0, size = 25) =>
    apiFetch<Page<CompanyInMarket>>(
      `/markets/countries/${encodeURIComponent(code)}/companies?page=${page}&size=${size}`,
    ),
};
